import { render, staticRenderFns } from "./PartnerClasses.vue?vue&type=template&id=3f9755b9&scoped=true"
import script from "./PartnerClasses.vue?vue&type=script&lang=js"
export * from "./PartnerClasses.vue?vue&type=script&lang=js"
import style0 from "./PartnerClasses.vue?vue&type=style&index=0&id=3f9755b9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9755b9",
  null
  
)

export default component.exports